//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
import pageHead from '@/component/page-header.vue';
import functionTitle from '@/component/function-title.vue';
import functionList from '@/component/function-list.vue';

export default {
  components: {
    pageHead,
    functionList,
    functionTitle
  },
  name: 'service',
  data() {
    return {
      listservice: [
        {
          url: './#/initiate-rights',
          icon: 'icon-activist',
          backcolor: '#ff515b',
          title: '一键维权'
        },
        {
          url: './#/assessment',
          icon: 'icon-remind',
          backcolor: '#59a3ff',
          title: '年度考核'
        },
        {
          url: './#/member',
          icon: 'icon-card',
          backcolor: '#13cad3',
          title: '电子会员卡'
        },
        {
          url: './#/prove-apply',
          icon: 'icon-apply',
          backcolor: '#f7a851',
          title: '证明申请'
        },
        {
          url: './#/party-member-pay',
          icon: 'icon-hurt-',
          backcolor: '#fe6357',
          title: '党员服务'
        },
        {
          url: 'javascript:;',
          icon: 'icon-log',
          backcolor: '#89abf8',
          title: '实习日志'
        },
        {
          url: 'javascript:;',
          icon: 'icon-many',
          backcolor: '#98d270',
          title: '更多'
        }
      ],
      listwelfare: [
        {
          url: 'javascript:;',
          icon: 'icon-order',
          backcolor: '#ffbf14',
          title: '预约体验'
        },
        {
          url: 'javascript:;',
          icon: 'icon-subscribe',
          backcolor: '#89abf8',
          title: '预约办事'
        },
        {
          url: 'javascript:;',
          icon: 'icon-many',
          backcolor: '#98d270',
          title: '更多'
        }
      ]
    };
  },
  methods: {
    ...mapActions([])
  },
  watch: {},
  computed: {
    ...mapGetters([])
  },
  created() {},
  mounted() {
    let elem = document.querySelector('#vux_view_box_body');
    setTimeout(() => {
      elem.style.paddingBottom = '44px';
    }, 10);
  }
};
